import type { AgencyDashboardPeriod } from "@/integrations/supabase/rpc-types";
import type { TranslationKey } from "@/types/i18n.types";

export const PERIOD_OPTIONS: { value: AgencyDashboardPeriod; labelKey: TranslationKey }[] = [
  { value: "7d", labelKey: "dashboard.overview.period7d" },
  { value: "30d", labelKey: "dashboard.overview.period30d" },
  { value: "90d", labelKey: "dashboard.overview.period90d" },
  { value: "ytd", labelKey: "dashboard.overview.periodYtd" },
];
